import React from 'react';
import {Panel} from 'rsuite'

const Card = props => (
    <Panel {...props} header={props.title} style={{background: 'white', marginTop: '.7em', ...props.style}}>
      {props.children}
    </Panel>
  );

export default Card;